import React from 'react'
import { Result } from '../types/types'

type Props = {
  products: Result[]
  collections?: Result[] | null
  pages?: Result[] | null
  resultDisplaying?: string
  handleResultClick: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

function ProductInstantSearchSuggestions({products, collections, pages, resultDisplaying, handleResultClick}: Props) {
  if (!products) {
    return null
  }

  return (
    <div className='flex mx-5 md:mx-0 flex-wrap justify-center md:flex-nowrap'>
      {products ? 
        <a key={1} id="products" onClick={(e) => handleResultClick(e)} 
        className={`text-base-2 cursor-pointer ${resultDisplaying == "products" ? 'text-black' : 'text-inactive-state'} uppercase mr-SM md:mr-DSM`}>
          products
        </a>
      :
        null
      }

      {collections && collections.length ? 
        <a key={2} id="collections" onClick={(e) => handleResultClick(e)} 
        className={`text-base-2 cursor-pointer ${resultDisplaying == "collections" ? 'text-black' : 'text-inactive-state'} uppercase mr-SM md:mr-DSM`}>
          collections
        </a>
      :
        null
      }

      {pages && pages.length ? 
        <a key={3} id="pages" onClick={(e) => handleResultClick(e)} 
        className={`text-base-2 cursor-pointer ${resultDisplaying == "pages" ? 'text-black' : 'text-inactive-state'} uppercase mr-SM md:mr-DSM`}>
          pages
        </a>
      :
        null
      }
  </div>
  )
}

export default ProductInstantSearchSuggestions